<template>
  <v-app>
    <Navbar/>
    <v-main>
      <router-view/>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
import Navbar from '@/components/menus/Navbar.vue';
import Footer from '@/components/menus/Footer.vue';

export default {
  name: 'App',

  data: () => ({
    //
  }),

  components: {
    Navbar,
    Footer,
  },
};
</script>
